import { AuthenticatedDataRequest } from '@eggplant/data-request'
import { SPACE_SERVICE } from '@eggplant/api-hosts'
import type {
  Space,
  SpacePostBody
} from '@eggplant/types'

interface Props {
  requestBody: SpacePostBody
  onSuccess: (response: Space) => void
}

const SpaceCreateRequest = ({
  onSuccess,
  requestBody
}: Props) => {
  const url = `${SPACE_SERVICE}/spaces`

  return (
    <AuthenticatedDataRequest
      method='post'
      onSuccess={onSuccess}
      params={requestBody}
      url={url}
    />
  )
}

export default SpaceCreateRequest
